export const getLeftMenuData = [
  {
    title: 'Dashboard',
    key: 'projectDashboard',
    url: '/dashboard',
    icon: 'fa fa-desktop',
    roles: ['Admin', 'Project Manager', 'Staff', 'Project Reviewer', 'Engagement Manager', 'Senior Staff', 'Project Staff', 'Assisting Staff'],
  },
  {
    title: 'Restore Project',
    key: 'restoreProject',
    url: '/restoreproject',
    icon: 'fa fa-recycle',
    roles: ['Admin', 'Project Reviewer', 'Engagement Manager', 'Senior Staff', 'Project Staff', 'Assisting Staff'],
  },
  {
    key: 'template',
    title: 'Templates',
    url: '/templates',
    icon: 'fa fa-braille',
    roles: ['Admin', 'Project Manager', 'Project Reviewer', 'Engagement Manager'],
  },
  {
    key: 'users',
    title: 'Users',
    url: '/users',
    icon: 'fa fa-users',
    roles: ['Admin'],
  },
  {
    key: 'masterData',
    title: 'Master Data',
    url: '/master',
    icon: 'fa fa-table',
    roles: ['Admin', 'Project Manager', 'Staff', 'Project Reviewer', 'Engagement Manager', 'Senior Staff', 'Project Staff', 'Assisting Staff'],
  },
  {
    key: 'setting',
    title: 'Setting',
    url: '/setting',
    icon: 'fa fa-sliders',
    roles: ['Admin'],
  },
]
